const lbaFeatureSelect = angular.module('app.lbaFeatureSelect', []);

lbaFeatureSelect.controller('lbaFeatureSelectCtrl', require('./lbaFeatureSelectCtrl'));
lbaFeatureSelect.directive('lbaFeatureSelect', require('./lbaFeatureSelectDir'));

export default lbaFeatureSelect;



// WEBPACK FOOTER //
// ./src/components/lbaFeatureSelect/index.js